import styled, { css } from 'styled-components'
import { Link as RouterLink, NavLink as RouterNavLink } from 'react-router-dom'

import variables from 'assets/styles/variables.js'
import { styles } from 'gipsy-misc'

export const Header = styled.div`
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  z-index: 99;
  height: ${variables.headerHeight};
  background-color: ${variables.headerBackgroundColor};
  border-bottom: 1px solid ${styles.colors.borderColor};
  display: flex;
  justify-content: center;
  flex-direction: row;
  flex: 1 1;
  flex-wrap: wrap;
`

export const Content = styled.div`
  max-width: 1200px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

export const Tabs = styled.div`
  margin-left: -20px;
  height: ${variables.headerHeight};
  display: flex;
  flex-direction: row;
`

const linkCss = css`
  && {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    font-size: ${styles.fonts.fontSizeXSmall};
    font-weight: 500;
    height: ${variables.headerHeight};
    padding: 0 20px;
    text-decoration: none;
    color: ${styles.colors.textLightColor};
    transition: color 0.1s ease-in-out;
    position: relative;
    &:hover {
      svg,
      g,
      path {
        fill: ${styles.colors.primaryColor};
      }
    }
  }
`

export const NavLink = styled(RouterNavLink)`
  ${linkCss}
  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    right: 20px;
    left: 20px;
    height: 1px;
    background-color: ${styles.colors.primaryColor};
    transform: scale(0);
    transition: all 0.07s ease-in-out;
  }
  &:hover,
  &.active {
    color: ${styles.colors.primaryColor};
    &:after {
      transform: scale(1);
    }
  }
`

export const Link = styled(RouterLink)`
  ${linkCss}
  &:after {
    content: '';
    position: absolute;
    top: 0;
    right: 10px;
    left: 10px;
    height: 2px;
    background-color: ${styles.colors.primaryColor};
    transform: scale(0);
    transition: all 0.07s ease-in-out;
  }
  &:hover,
  &.active {
    color: ${styles.colors.primaryColor};
    &:after {
      transform: scale(1);
    }
  }
`



// WEBPACK FOOTER //
// ./src/features/layout/components/header/index.js